import { render } from "./EmployeePayRegister.vue?vue&type=template&id=deea4d2a"
import script from "./EmployeePayRegister.vue?vue&type=script&lang=js"
export * from "./EmployeePayRegister.vue?vue&type=script&lang=js"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__